<template>
  <fragment>
    <!-- 데이터 테이블 -->
    <PagingTable ref="table" :sourceList="tableItems">
      <template #header>
        <caption>
          <span class="blind">대상자별 소식 목록</span>
        </caption>
        <colgroup>
          <col width="5%" />
          <!-- <col width="18%" /> -->
          <col />
          <col width="8%" />
          <col width="10%" />
          <col width="10%" />
          <col width="8%" />
          <col width="10%" />
          <col width="15%" />
        </colgroup>
        <thead class="table_list_head">
          <tr>
            <th class="sorting" data-sort="id">번호</th>
            <!-- <th class="sorting" data-sort="rcpDesc">받는사람</th> -->
            <th class="sorting" data-sort="boardTitle">제목</th>
            <th class="sorting" data-sort="userName">작성자</th>
            <th class="sorting" data-sort="createDate">작성시간</th>
            <th class="sorting" data-sort="pushFirstDate">최초전송시간</th>
            <th class="sorting" data-sort="pushStatus">스피커알림</th>
            <th class="sorting" data-sort="checkedDate">확인 시간</th>
            <th>수정/삭제</th>
          </tr>
        </thead>
      </template>

      <template #row="{rowData}">
        <tr>
          <td>{{ rowData.id }}</td>
          <!-- <td>
            <span v-if="rowData.onlyOneRcpId">{{rowData.rcpDesc}}</span>
            <button
              v-else
              type="button"
              class="link_modal"
              @click="openRecipientList({ newsId: rowData.id })"
            >{{rowData.rcpDesc}}</button>
          </td>-->
          <EditedTextColumn
            :value="rowData.boardTitle"
            :rowData="rowData"
            :maxLength="60"
            @click="openGeneralDetail({newsId: rowData.id})"
          />
          <td>{{ rowData.userName }}</td>
          <td>{{ $utils.timeText(rowData.createDate) }}</td>
          <PushFirstDateColumn :newsData="rowData" />
          <PushStatusColumn displayType="RCP" :statusCode="rowData.pushStatus" :failMessageCode="rowData.pushFailDetail" />
          <td>{{ $utils.timeText(rowData.readDate) }}</td>
          <td>
            <template v-if="rowData.modifiable">
              <button type="button" class="btn_function blue" @click="onClickResend(rowData.id)" :disabled="!rowData.resendButtonEnable">
                알림 재전송
              </button>
              <button type="button" class="btn_function" @click="onClickExclude(rowData.id)">대상자 제외</button>
            </template>
            <template v-else>-</template>
          </td>
        </tr>
      </template>
    </PagingTable>

    <!-- 버튼 영역 -->
    <div class="section_button">
      <ExcelDownloadButton v-if="res" :filename="$utils.excelName('일반소식', res.rcpName)">
        <ExcelTable :sourceList="tableItems" />
      </ExcelDownloadButton>
      <HelpButton contentId="HELP_00" />
      <button type="button" class="btn_register" @click="openGeneralRegister({onSubmit: loadData})" :disabled="!isRegister">등록</button>
    </div>
  </fragment>
</template>

<script>
import newsMixin from '$views/News/_mixin';
import ExcelTable from './excelTables/Recipient.general';

export default {
  mixins: [newsMixin],
  components: {
    ExcelTable,
  },
  props: {
    rcpId: String,
    registerType: String,
  },
  data() {
    return {
      res: null,
    };
  },
  computed: {
    tableItems() {
      if (!this.res) return null;
      return this.res.boardList;
    },
  },
  methods: {
    async onClickResend(newsId) {
      confirm(`${this.res.rcpName}님에게 재전송 하시겠습니까?`).then(async () => {
        await this.$axios.put(`/admin/happy/news/${newsId}/resend`, {
          rcpIdList: [this.rcpId],
        });
        alert(`${this.res.rcpName}님에게 재전송 하였습니다.`);
        this.loadData(true);
      });
    },
    async onClickExclude(newsId) {
      confirm(`${this.res.rcpName}님을 소식 대상자에서 제외 하시겠습니까?`).then(async () => {
        await this.$axios.put(`/admin/happy/news/${newsId}/rcp/${this.rcpId}/exclude`);
        alert(`${this.res.rcpName}님이 이 소식을 들을 수 없도록 처리되었습니다.`);
        this.loadData(true);
      });
    },
    requestOptions() {
      return {params: {searchNewsType: this.registerType}};
    },
    loadData(keepTableState) {
      const options = this.requestOptions();
      this.$axios.get(`/admin/happy/news/rcp/${this.rcpId}`, options).then(({data}) => {
        this.res = data.data;
        this.$emit('dataLoaded', this.res);
        if (!keepTableState && this.$refs.table) this.$refs.table.resetState();
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
